import React, { FC } from 'react';
import styled from 'styled-components';
import { mobile, tablet } from 'styles/breakpoints';
import Text from 'components/Text';
import ContinueButton from './QuizContinueButton';
import { DynamicImage } from 'components';
import { table } from 'console';
import { useSelector } from 'react-redux';
import { AppState } from 'state/types';

interface InfoProps {
  onContinue: () => void;
  topText: string;
  title: string;
  upperText: string;
  buttonTitle: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 6.25rem 1rem 3rem;
  @media ${tablet} {
    padding: 2.375rem 1rem;
  }
`;

const Title = styled(Text)`
  color: #fff;
  text-align: center;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.375rem;
  span {
    color: #f7c800;
  }
  @media ${tablet} {
    font-size: 1.375rem;
    line-height: 2rem;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 28.75rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TopText = styled(Text)`
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 0.75rem;
  @media ${tablet} {
    font-size: 0.875rem;
    line-height: 2rem;
  }
`;

const BottomText = styled(Text)`
  color: #fff;
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  bottom: 6.25rem;
  padding: 0 1rem;
  max-width: 28.75rem;
  width: 100%;
`;

const zodiacInPlural = {
  aries: 'Aries',
  taurus: 'Tauruses',
  gemini: 'Geminis',
  cancer: 'Cancers',
  leo: 'Leos',
  virgo: 'Virgos',
  libra: 'Libras',
  scorpio: 'Scorpios',
  sagittarius: 'Sagittariuses',
  capricorn: 'Capricorns',
  aquarius: 'Aquariuses',
  pisces: 'Pisces',
};

const Info: FC<InfoProps> = ({
  topText,
  title,
  upperText,
  buttonTitle,
  onContinue,
  ...props
}) => {
  const quizAnswers = useSelector((state: AppState) => state.user.quiz_answers);

  const resolveTitle = (title: string) => {
    const capitalizeFirstLetter = (string: string) =>
      string?.charAt(0).toUpperCase() + string.slice(1);

    if (quizAnswers?.gender === 'other') {
      const resolvedZodiac = title.replace(
        '${zodiac}',
        zodiacInPlural[quizAnswers?.zodiacSign],
      );
      return resolvedZodiac.replace('${gender}', '');
    }

    const capitalizedZodiac = capitalizeFirstLetter(quizAnswers?.zodiacSign);

    return title
      .replace('${zodiac}', capitalizedZodiac)
      .replace('${gender}', `${quizAnswers?.gender}s`);
  };

  return (
    <Container {...props}>
      <Content>
        <TopText>{topText}</TopText>
        <Title dangerouslySetInnerHTML={{ __html: resolveTitle(title) }} />
      </Content>

      <ContinueButton
        title={buttonTitle}
        onClick={onContinue}
        upperText={upperText}
      />
    </Container>
  );
};

export default Info;
